export default __webpack_public_path__ + "static/media/about-page-img.8c846e8a.jpg";